module.exports = __webpack_public_path__ + "static/media/wasabi-bnw-selected.25a65166.png";